import React from "react";
import {
  View,
  ScrollView,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
} from "react-native";
import AppTheme from "../../../AppTheme";

import appStyles from "../../../../appStyles";
import ImageComponent from "../../../common/ImageComponent";
import integrationStyles from "../../onboarding/integrationStyles";

export default function EmailSent({
  onButtonPress = () => {},
  isFromCard = false,
}) {
  return (
    <ScrollView
      style={(appStyles.scrollView, { paddingHorizontal: 16 })}
      contentContainerStyle={appStyles.scrollViewContent}
    >
      <Text style={styles.sectionText}>
        Our Chrome Extension installs on your desktop, so we’ve emailed you a
        link with instructions to set it up.
      </Text>

      <View
        style={{
          alignItems: "center",
          marginTop: 60,
          marginBottom: 35,
        }}
      >
        <ImageComponent
          image={require("../../../../../assets/integrations/chromeBig.png")}
          style={styles.desktopIcon}
        />
      </View>

      <Text style={styles.sectionText}>
        Please install as soon as possible for the best experience!
      </Text>

      <View style={[integrationStyles.buttons]}>
        <TouchableOpacity
          onPress={onButtonPress}
          style={integrationStyles.greenButton}
        >
          <Text style={integrationStyles.greenButtonText}>{"Done"}</Text>
        </TouchableOpacity>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  sectionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    marginTop: 32,
    textAlign: "center",
  },
  desktopIcon: {
    width: 279,
    height: 266,
  },
});
